import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getStatusEmp, getDownloadExcel } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";

export const StatusEmployeeContext = createContext({});
export const StatusEmployeeContextProvider = ({ children }) => {
  const location = useLocation();
  const [empStatus, setEmpStatus] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [zoneNewExcel, setZoneNewExcel] = useState("");
  const [currentPageData, setCurrentPageData] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  const [downloadExcel, setDownloadExcel] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  const downloadExcelSheet = async () => {
    setSpinnerStatus(true);
    const data = {
      search: "status",
      filter: "emp",
      empData: location?.state?.empdata,
      fromDate: "",
      toDate: "",
      zoneFilter: "",
      categoryFilter: "",
    };
    try {
      const response = await getDownloadExcel(data);
      if (response.data.status === 200) {
        setSpinnerStatus(false);
        setZoneNewExcel(response?.data?.data?.filename);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  useEffect(() => {
    downloadExcelSheet();
  }, []);

  const dataFilteredemp = async (pageNumber) => {
    const data = {
      page: pageNumber || 1,
      filter: "emp",
      empdata: location?.state?.empdata,
    };

    try {
      const response = await getStatusEmp(data);
      if (response.status === 200) {
        setEmpStatus(response?.data?.data?.employees);
        setPageCount(response?.data?.data?.numPages);
      }
    } catch (error) {
      if (error.status === 401 || error.status === 400) {
        const errorMessage = error.response.data.message;
        setErrorMessage(errorMessage);
      } else {
        setErrorMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    //statusEmpData();
    dataFilteredemp();
  }, []);

  const onPageChange = (e) => {
    dataFilteredemp(e);
    setCurrentPageData(e);
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const providerValue = {
    goBack,
    currentPageData,
    pageCount,
    onPageChange,
    empStatus,
    zoneNewExcel,
    downloadExcel,
    spinnerStatus,
    setShowAlert,
    showAlert,
    alertMessage,
    statusCode,
    logout,
  };
  return (
    <StatusEmployeeContext.Provider value={providerValue}>
      {children}
    </StatusEmployeeContext.Provider>
  );
};
